import client from './client';

export const getAllCategory = () => client.get(`/category`);
export const get3DepCategory = ({ curSelCateId }) => client.get(`/category/${curSelCateId}`);
export const getFilters = ({ curSelCateId }) => client.get(`/category/${curSelCateId}/filter`);

